<template>
  <div class="bill-info">
    <div class="title">{{$t('PCUserInfo.index.647kboa09440')}}</div>
    <div class="item">
      <div class="item-left">BIC</div>
      <div class="item-right">
        <input v-model="form.bic" type="text" :placeholder="$t('PCUserInfo.index.647kboa09u40')">
      </div>
    </div>
    <div class="item">
      <div class="item-left">IBAN</div>
      <div class="item-right">
        <input v-model="form.iban" type="text" :placeholder="$t('PCUserInfo.index.647kboa09u40')">
      </div>
    </div>
  </div>
</template>



<script>
export default {
  name: "billInfo",
  props: {},
  data () {
    return {
      form: {
        bic: '',
        iban: '',
      }
    }
  },
  watch: {
    /**
     * 监听表单数据填写
     */
    form: {
      deep: true,
      immediate: true,
      handler: function (val) {
        let flag = Boolean(val && val.bic && val.iban)
        let data = {
          flag,
          form: val
        }
        this.$emit('completeBill', data)
      }
    }
  },
  methods: {
  }
};
</script>

<style scoped lang='less'>
.bill-info {
  width: 100%;
  box-sizing: border-box;
  color: #fff;
  margin-bottom: 24px;
  background: #fff;
  border-radius: 20px;
  padding: 0 24px;
  .title {
    height: 84px;
    font-size: 32px;
    font-weight: 500;
    color: #333;
    line-height: 84px;
  }
  .item {
    padding: 30px 0px 29px 0px;
    display: flex;
    align-items: center;
    border-bottom: 1px solid #F4F5F7;
    position: relative;
    .item-left {
      width: 170px;
      font-size: 28px;
      color: #5D5F65;
      margin-right: 32px;
    }
    .item-right {
      flex: 1;
      color: #333;
      input {
        border: none;
        padding: 0;
        font-size: 28px;
      }
      input::placeholder {
        color: #999;
        font-size: 28px;
      }
      .error-tip {
        color: #F00;
        font-size: 24px;
        position: absolute;
        bottom: 0;
      }
      .input {
        display: flex;
        align-items: center;
        justify-content: space-between;
        .btn {
          padding: 12px;
          color: #fff;
          background: #FF9600;
          font-size: 24px;
          border-radius: 10px;
        }
      }
    }
  }
  .item:last-child {
    border-bottom: none;
  }
}
</style>
